type OpacityOverrideConfig = {
  opacity_override?: number | null;
  opacityOverride?: number | null;
};

/**
 * Widget / API may expose 0–100 as `opacity_override` (snake_case) or `opacityOverride` (camelCase).
 * Converts to 0–1 for map tiles and legend images. Uses nullish checks so 0% is valid.
 */
export function mapLayerOpacityOverrideToFraction(
  config: OpacityOverrideConfig,
  fallback = 0.8,
): number {
  const raw = config.opacity_override ?? config.opacityOverride;
  if (raw == null) return fallback;
  const n = Number(raw);
  if (!Number.isFinite(n)) return fallback;
  return n / 100;
}
